import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import AOS from "aos";
import "aos/dist/aos.css";
import ProductPage from "./pages/ProductPage";
import { useDispatch, useSelector } from "react-redux";
import AboutUs from "./pages/AboutUs";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogDetail";
import Faqs from "./pages/Faqs";
import ShippingDetails from "./pages/ShippingDetails";
import ExchangePolicy from "./pages/ExchangePolicy";
import CancellationRefundPolicy from "./pages/CancellationRefundPolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import StoreLocator from "./pages/StoreLocator";
import Cart from "./pages/Cart";
import SuccesPage from "./pages/SuccesPage";
import Products from "./pages/Products";
import Orders from "./pages/Orders";
import OrderDetailsPage from "./pages/OrderDetailsPage";
import Profile from "./pages/Profile";
import CheckoutPage from "./pages/CheckoutPage";
import Register from "./pages/Register";
import Error from "./pages/Error";
import Wishlist from "./pages/Wishlist";
import TrackOrder from "./pages/TrackOrder";

const App = () => {
  const isLoggedIn = useSelector((state) => state.isLoggedIn);
  const userId = useSelector((state) => state.userId);
  const dispatch = useDispatch();

  useEffect(() => {
    const localStr = JSON.parse(localStorage.getItem("state"));
    if (localStr) {
      dispatch({ type: "reload", data: { ...localStr } });
    }
    AOS.init({ once: true });
  }, [dispatch]);

  useEffect(() => {
    const fetchWishlist = async () => {
      if (isLoggedIn && userId) {
        try {
          const res = await fetch(`${process.env.REACT_APP_BASE_URL}/user/wishlist/get`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId }),
          });
          const data = await res.json();
          if (data.success) {
            dispatch({ type: "setWishlist", wishlistItems: data.wishlist });
          }
        } catch (err) {
          console.error("Failed to fetch wishlist:", err);
        }
      }
    };
    fetchWishlist();
  }, [isLoggedIn, userId, dispatch]);

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/not-found" exact element={<Error />} />
        {isLoggedIn && <Route path="/login" element={<Navigate to="/" />} />}
        {!isLoggedIn && <Route path="/login" element={<Login />} />}
        {isLoggedIn && <Route path="/account/:userId" element={<Profile />} />}
        <Route path="/product/:category/:product/:productId" exact element={<ProductPage />} />
        <Route path="/cart" exact element={<Cart />} />
        <Route path="/about-us" exact element={<AboutUs />} />
        <Route path="/blogs" exact element={<Blogs />} />
        <Route path="/blogs/:slug" exact element={<BlogDetail />} />
        <Route path="/faqs" exact element={<Faqs />} />
        <Route path="/shipping-details" exact element={<ShippingDetails />} />
        <Route path="/exchange-policy" exact element={<ExchangePolicy />} />
        <Route path="/cancellation-refund-policy" exact element={<CancellationRefundPolicy />} />
        <Route path="/privacy-policy" exact element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" exact element={<CookiePolicy />} />
        <Route path="/store-locator" exact element={<StoreLocator />} />
        <Route path="/account/:userId/orders" exact element={<Orders />} />
        <Route path="/account/:userId/orders/:orderId" exact element={<OrderDetailsPage />} />
        <Route path="/success" exact element={<SuccesPage />} />
        <Route path="/register" exact element={<Register />} />
        <Route path="/checkout" exact element={<CheckoutPage />} />
        <Route path="/product-category/:category" exact element={<Products />} />
        <Route path="/wishlist" exact element={<Wishlist />} />
        <Route path="/track-order" exact element={<TrackOrder />} />
        <Route path="*" exact element={<Error />} />
      </Routes>
    </>
  );
};

export default App;
